/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CostTypeDto } from '../models/cost-type-dto';
import { CostTypeDtoPage } from '../models/cost-type-dto-page';
import { createCostType } from '../fn/cost-types/create-cost-type';
import { CreateCostType$Params } from '../fn/cost-types/create-cost-type';
import { deleteCostType } from '../fn/cost-types/delete-cost-type';
import { DeleteCostType$Params } from '../fn/cost-types/delete-cost-type';
import { getCostType } from '../fn/cost-types/get-cost-type';
import { GetCostType$Params } from '../fn/cost-types/get-cost-type';
import { listCostTypes } from '../fn/cost-types/list-cost-types';
import { ListCostTypes$Params } from '../fn/cost-types/list-cost-types';
import { updateCostType } from '../fn/cost-types/update-cost-type';
import { UpdateCostType$Params } from '../fn/cost-types/update-cost-type';

@Injectable({ providedIn: 'root' })
export class CostTypesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listCostTypes()` */
  static readonly ListCostTypesPath = '/v0/costTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCostTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCostTypes$Response(params?: ListCostTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDtoPage>> {
    return listCostTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCostTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCostTypes(params?: ListCostTypes$Params, context?: HttpContext): Observable<CostTypeDtoPage> {
    return this.listCostTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<CostTypeDtoPage>): CostTypeDtoPage => r.body)
    );
  }

  /** Path part for operation `createCostType()` */
  static readonly CreateCostTypePath = '/v0/costTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCostType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCostType$Response(params: CreateCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDto>> {
    return createCostType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCostType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCostType(params: CreateCostType$Params, context?: HttpContext): Observable<CostTypeDto> {
    return this.createCostType$Response(params, context).pipe(
      map((r: StrictHttpResponse<CostTypeDto>): CostTypeDto => r.body)
    );
  }

  /** Path part for operation `getCostType()` */
  static readonly GetCostTypePath = '/v0/costTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCostType()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCostType$Response(params: GetCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<CostTypeDto>> {
    return getCostType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCostType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCostType(params: GetCostType$Params, context?: HttpContext): Observable<CostTypeDto> {
    return this.getCostType$Response(params, context).pipe(
      map((r: StrictHttpResponse<CostTypeDto>): CostTypeDto => r.body)
    );
  }

  /** Path part for operation `updateCostType()` */
  static readonly UpdateCostTypePath = '/v0/costTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCostType()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCostType$Response(params: UpdateCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCostType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCostType$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCostType(params: UpdateCostType$Params, context?: HttpContext): Observable<void> {
    return this.updateCostType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteCostType()` */
  static readonly DeleteCostTypePath = '/v0/costTypes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCostType()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCostType$Response(params: DeleteCostType$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCostType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCostType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCostType(params: DeleteCostType$Params, context?: HttpContext): Observable<void> {
    return this.deleteCostType$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
